(ns quuppa.qsm.projects.view
  "Projects list"
  (:require [clojure.string :as str]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as rfe]
            [quuppa.components :as c]
            [quuppa.peweb.query :as q]
            [quuppa.ui.button :refer [button]]
            [quuppa.ui.layout :as layout]
            [quuppa.qsm.events :as e]
            [quuppa.qsm.projects.subs :as ps]
            [quuppa.qsm.projects.events :as pe]
            [quuppa.qsm.projects.project-view :as project]
            [quuppa.qsm.site.events :as se]
            [quuppa.qsm.ui-state.subs :as state-subs]
            [quuppa.qsm.permissions :as permissions]))

;; This is also used by sub-routes
(def projects-controller
  {:id :projects
   :identity nil
   :start (fn [_]
            (q/execute e/authorized-qpes {})
            (q/execute pe/projects-query {}))
   :subscriptions (fn [_]
                    [[:qsm/project-add]
                     [:qsm/project-update]
                     [:qsm/project-remove]
                     ;; TODO: We could limit site events to certain projects,
                     ;; when on a page for specific project.
                     [:qsm/site-add]
                     [:qsm/site-update]
                     [:qsm/site-remove]

                     ;; subs to updating QPE states
                     [:qpe/add]
                     [:qpe/update]
                     [:qpe/revoked-authorization]
                     [:qpe/status]

                     [:qsm/qpe-groups]])})

;; Only for the list view
;; Stop is called when entering the project view
(def projects-list-controller
  {:id :projects
   :identity nil
   :stop (fn [_]
           ;; Close add project form when navigating out of projects list
           (rf/dispatch [::pe/cancel-project-form])
           ;; Close new site form
           (rf/dispatch [::se/cancel-site-form]))})

(defn new-project-form []
  (let [form @(rf/subscribe [::ps/project-form])]
    (when form
      (let [{:keys [data error]} form]
        [layout/sidebar
         [layout/sidebar-header
          {:title "New project"
           :on-close #(rf/dispatch [::pe/cancel-project-form])}]

         [project/project-form
          {:on-submit #(rf/dispatch [::pe/save-new-project])
           :on-cancel #(rf/dispatch [::pe/cancel-project-form])
           :on-field-change #(rf/dispatch [::pe/project-form-set-value %1 %2])
           :error error
           :data data}]]))))

(defn projects-page []
  (let [{projects :result initial? :initial-load error :error} @(q/subscribe pe/projects-query {})
        projects (some->> projects not-empty (sort-by (comp str/lower-case :name)))
        sidebar @(rf/subscribe [::state-subs/ui-state :projects :sidebar])
        is-qsm-owner? (permissions/is-qsm-owner?)]
    [layout/section
     [layout/view-content
      {:sidebar-open (:type sidebar)}

      [layout/section-header
       {:title [:h1.mb-0
                [:span "Projects " [:span.text-gray-500 (count projects)]]]
        :actions (when is-qsm-owner?
                   [button
                    {:variant "primary"
                     :start-icon :plus
                     :attr     {:data-test-id "new-project-button"}
                     :on-click #(rf/dispatch [::pe/init-new-project-form])}
                    "New project"])}]
      (when error
        [c/error-alert error])
      [:div
       (doall
         (if initial?
           (for [i (range 3)]
             ^{:key (str "project-placeholder-" i)}
             [:div.d-flex.p-3.project-sites.my-1.placeholder-glow
              [:h2.placeholder {:class (str "px-" (rand-int 5))} "Loading..."]])
           (if (seq projects)
             (for [project projects]
               (let [owner-or-admin? (or (permissions/has-manage-permission?)
                                         (permissions/has-manage-permission-to-resource? project))]
                 [:div.d-flex.p-3.flex-column.project-sites.mb-3
                  {:key (:id project)}
                  [:div.d-flex.flex-row
                   [:h2.flex-grow-1
                    [:a.text-decoration-none.fw-medium
                     {:href (rfe/href :project {:project-id (:id project)})
                      :data-test-id (str "project-link-title-" (:name project))}
                     (:name project)]]
                   (when owner-or-admin?
                     [button
                      {:variant "light"
                       :outline true
                       :class "border-gray-200 text-gray-700"
                       :start-icon :plus
                       :on-click #(rf/dispatch [::se/init-new-site-form :projects (:id project)])}
                      "Add site"])]

                  ;; Maybe display only the first line?
                  (let [desc-lines (str/split (:description project) #"\n")]
                    [:p.text-pre-wrap
                     (first desc-lines)
                     (when (seq (rest desc-lines))
                       "...")])
                  [:f> project/sites-grid project (fn [_] [:p.text-muted.text-center.lead "No sites in this project"])]]))
             [:div.alert.alert-info "No projects yet"])))]]
     (case (:type sidebar)
       :new-project-form [new-project-form]
       :new-site-form [project/new-site-form]
       nil)]))
